<div class="flex items-center justify-end mb-5">
	<button class="bg-primary text-[12px] text-white px-4 py-2 rounded-lg flex items-center gap-2"
		(click)="onAddContact()">
		<lucide-icon [img]="Plus" [size]="16"></lucide-icon>
		Ajouter un contact
	</button>
</div>

<!-- État de chargement -->
@if (loading) {
<div class="flex items-center justify-center py-8">
	<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
	<span class="ml-2 text-sm text-gray-600">Chargement des contacts...</span>
</div>
}

<!-- État d'erreur -->
@if (error && !loading) {
<div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
	<div class="flex items-center">
		<div class="text-red-600 text-sm">{{ error }}</div>
	</div>
</div>
}

<!-- Tableau des contacts -->
@if (!loading && !error) {
<div class="border border-solid border-gray-200 rounded overflow-hidden">
	<div class="overflow-x-auto">
		<table class="table w-full">
			<thead>
				<tr class="bg-gray-50">
					<th class="text-sm font-medium text-gray-700 px-4 py-3 text-left">Prénom</th>
					<th class="text-sm font-medium text-gray-700 px-4 py-3 text-left">Nom</th>
					<th class="text-sm font-medium text-gray-700 px-4 py-3 text-left">Type</th>
					<th class="text-sm font-medium text-gray-700 px-4 py-3 text-left">Numéro mobile</th>
				</tr>
			</thead>
			<tbody>
				@if (contacts.length > 0) {
				@for (contact of contacts; track contact.firstName + contact.lastName) {
				<tr class="border-b border-gray-200 hover:bg-gray-50">
					<td class="px-4 py-3 text-sm text-gray-900">{{ contact.firstName }}</td>
					<td class="px-4 py-3 text-sm text-gray-900">{{ contact.lastName }}</td>
					<td class="px-4 py-3 text-sm text-gray-900">{{ contact.type }}</td>
					<td class="px-4 py-3 text-sm text-gray-900">{{ contact.mobileNumber | phoneNumber }}</td>
				</tr>
				}
				} @else {
				<tr>
					<td colspan="4" class="px-4 py-8 text-center text-sm text-gray-500">
						Aucun contact trouvé
					</td>
				</tr>
				}
			</tbody>
		</table>
	</div>
</div>
}